<template>
	<div class="qualityenterprise">
		<leftnav class="fl" mkcode="C" itemcode="C-GLQYXS"></leftnav>
		<div class="index_left" :style="isCollapse?'margin-left: 0;width:100%':''">
			<govheader></govheader>
			<div class="index_left_centerpage">
				<div class="whitebox right_topbox has-title-font" style="padding-bottom: 1px;">
					<div class="right_boxtitle">
						<span class="fl right_title"
							v-if="curWebsite.type != 5 && curWebsite.type != 6">{{ curWebsite.keyword }}{{ curWebsite.type == 2
								? '' : '线索' }}</span>
						<span class="fl right_title" v-if="curWebsite.type == 5 || curWebsite.type == 6">产业排行榜</span>
					</div>
					<div class="opport-screen-list1">
						<div class="spage-searchbox ">
							<ClueNav tabCode="glqy"></ClueNav>
						</div>
						<!-- 省市区筛选 -->
						<cityScreen :key="refreshCity" @getEnterpriseList="cityScreenFun" :isShowCounty="false">
						</cityScreen>
						<dl class="opport-screen bdbe">
							<dt class="fl">企业实力</dt>
							<dd>
								<span class="a-screen" :key="i" v-for="(list, i) in scoreList"
									:class="score1 == list.id ? 'a-screen current' : 'a-screen'"
									@click="score1 = list.id; getEnterpriseList(1)">{{ list.name }}</span>
							</dd>
						</dl>
						<dl class="opport-screen bdbe">
							<dt class="fl">投资力度</dt>
							<dd>
								<span class="a-screen" :key="i" v-for="(list, i) in scoreList"
									:class="score2 == list.id ? 'a-screen current' : 'a-screen'"
									@click="score2 = list.id; getEnterpriseList(1)">{{ list.name }}</span>
							</dd>
						</dl>
						<dl class="opport-screen bdbe">
							<dt class="fl">本省关联度</dt>
							<dd>
								<span class="a-screen" :key="i" v-for="(list, i) in scoreList"
									:class="score3 == list.id ? 'a-screen current' : 'a-screen'"
									@click="score3 = list.id; getEnterpriseList(1)">{{ list.name }}</span>
							</dd>
						</dl>
						<!-- 概念产业筛选 -->
						<notionScreen :type="2" :key="pageRefreshKey" :notionNumberList="notionNumList"
							:refreshNum="notionNumRefresh" :token="userdata.token" @chooseNotion="chooseNotion"
							:isShowNotionScreen="true" :isClearNotion="isClearNotion"></notionScreen>
					</div>
				</div>
				<div class="whitebox" style="min-height: 160px;">
					<div class="enterparise_guide oh" style="width: 95%; ">
						<p class="fl">产业大脑为您找到<span class="searchnum">{{ total }}</span>条相关结果</p>
					</div>
					<div class="enterprise_list_box" v-show="enterprise_list.length != 0">
						<!-- 全部内资企业 带筛选 并且内容不同-->
						<table border="0" cellspacing="0" cellpadding="0" class="enterprise_table">
							<tr>
								<th>排名</th>
								<th>企业名称</th>
								<th>地区</th>
								<th>所属产业</th>
								<th v-for="(list, index) in dimensionList" :key="index">
									<div @click="tablesort(list.type);" :style="'width:' + list.name.length * 16 + 'px'"
										:class="{ 'td_sortname ': true, 'current': order_field == list.type }">
										<span
											:class="{ 'sortname ': true, 'current': order_field == list.type, 'fz15': list.name.length > 5 }">{{ list.name }}</span><span
											:class="order_type == 1 ? 'timesorticon up' : 'timesorticon down'"></span>
									</div>
								</th>
								<th>编辑</th>
							</tr>
							<tr :key="i" v-for="(list, i) in enterprise_list">
								<td>{{ (page - 1) * pageSize + i + 1 }}</td>
								<td class="title" @click="routerlinkid('/enterprises', list.stockCode)">
									{{ list.title }}
								</td>
								<td>{{ list.area }}</td>
								<td class="conpanytags hastag">
									<span class="span-tag" :key="index" v-for="(item, index) in list.notionlist"
										@click="tagrouter('/enterpriseTag', 0, 'notion', item.id, item.name)">{{ item.name }}</span>
									<span v-if="list.notionlist.length < 1">-</span>
								</td>
								<td>{{ list.landNum }}</td>
								<td>{{ list.landSize.toFixed(2) }}{{ list.landSize > 0 ? list.landSizeUnit : '' }}</td>
								<td>{{ list.projectNum }}</td>
								<td>{{ list.projectMoney }}{{ list.projectMoney > 0 ? list.projectMoneyUnit : '' }}</td>
								<td class="collectfont1"><span @click="listToggleCollect(list)">{{ list.collectId ==
									0 ? '加入' : '移除' }}<br />目标企业</span>
								</td>
							</tr>
						</table>
					</div>
					<div class="centerpage1 company_pagelist" v-show="totalPage > 1">
						<zpagenav v-bind:page="page" v-bind:page-size="pageSize" v-bind:total="total"
							v-bind:max-page="maxPage" v-on:pagehandler="getEnterpriseList"></zpagenav>
					</div>
				</div>
			</div>


		</div>
	</div>
</template>

<script>
import { mapState, mapMutations, mapGetters } from "vuex";

export default {
	name: 'enterpriseList',
	computed: {
		...mapState({
			isCollapse: (state) => state.isCollapse,
		}),
		...mapGetters(['isCollapse'])
	},
	data() {
		return {
			search_type: "notion",// notion（只有概念）  city （概念 城市）  strength（企业实力， 概念 城市） 
			curWebsite: this.$api.getWebsiteType(),
			title: "企业关联线索",
			fenkd: {
				children: []
			},
			userdata: {},
			notionCode: 0,
			chooseNotionlist: [0, 0, 0, 0, 0],
			notionNumRefresh: 1,
			isClearNotion: false,
			notionstep: 0,
			notionNumList: [],
			provinceid: 0,
			cityid: 0,
			countyid: 0,
			score1: 0,
			score2: 0,
			score3: 0,
			scoreList: [{ name: '全部', id: 0 }, { name: "A级", id: 1 }, { name: "B级", id: 2 }, { name: "C级", id: 3 }],
			refreshCity: 2,
			pageRefreshKey: 1,
			// provincedata: dataInJs(),
			// citydata: [],
			// countydata: [],  
			enterprise_list: [],
			order_field: 5, //排序字段 0 分数 1 时间
			order_type: 0, //排序方式 0 降序 1 升序   
			// 0=分数,1=融资时间,2=企业实力,3=投资力度,4=本省关联度,5=拿地数量,6=拿地面积,7=拿地金额,8=投资项目数量,9=投资项目金额,10=控制企业数量,11=专利数量
			dimensionList: [{
				name: '拿地数量',
				type: 5
			}, {
				name: '拿地面积',
				type: 6
			}, {
				name: '投资项目数量',
				type: 8
			}, {
				name: '投资项目金额',
				type: 9
			},],
			page: 1, //显示的是哪一页
			haspage: true, //是否还有下一页
			pageSize: 10, //每一页显示的数据条数
			total: 0, //记录总数
			totalPage: 1,
			maxPage: 10, //最大页数 
		}
	},
	created() {
		this.$nextTick(() => {
			document.oncontextmenu = new Function("event.returnValue=false"); // 禁用右键 
			document.onselectstart = new Function("event.returnValue=false"); // 禁用选择
		});
		this.userdata = this.getuseriformation();
	},
	mounted() {
		this.getEnterpriseList();
		// this.$api.cyl.investclue.relationEnterprise()
	},

	methods: {
		//时间/分数升降序
		tablesort(field) {
			if (field == this.order_field) {
				this.order_type = Math.abs(this.order_type - 1);
			} else {
				this.order_field = field;
			}
			this.getEnterpriseList();
		},
		//获取用户信息
		// getuserinfor() {
		// 	let dataddd = sessionStorage.getItem('userData') ? sessionStorage.getItem('userData') : localStorage
		// 		.getItem('userData');
		// 	if (typeof(dataddd) == 'object') {
		// 		this.userdata = dataddd;
		// 	} else {
		// 		this.userdata = JSON.parse(dataddd);
		// 	}
		// },
		//获取企业列表
		getEnterpriseList(pages) {
			this.bus.$emit('loading', true);
			this.page = pages ? pages : 1;
			var that = this;
			var queryData = {
				province: this.provinceid,
				city: this.cityid,
				score1: this.score1,
				score2: this.score2,
				score3: this.score3,
				notionCode: this.notionCode,
				orderField: this.order_field,
				orderType: this.order_type,
				page: this.page
			};
			var ajaxurl = this.$api.cyl.investclue.relationEnterprise(queryData);
			this.$axios.get(ajaxurl, {
				headers: {
					AuthToken: this.userdata.token
				}
			}).then(function (res) {
				if (res.data.success) {
					console.log(ajaxurl, '关联企业列表', res.data.list);
					var dataenterlist = res.data.list;
					for (var i = 0; i < res.data.list.length; i++) {
						dataenterlist[i].notionlist = that.taglistfun(dataenterlist[i].notion, dataenterlist[
							i].notionCode, 'notionsort');
						dataenterlist[i].taglist = that.taglistfun(dataenterlist[i].tag, dataenterlist[i]
							.tagCode);
					}
					that.totalPage = res.data.totalPage;
					that.pageSize = res.data.pageSize;
					that.total = res.data.totalRecord;
					that.haspage = res.data.list.length == res.data.pageSize;
					that.enterprise_list = dataenterlist;
				}
				that.bus.$emit('loading', false);
			})
		},
		cityScreenFun(pid, cid, cuid) {
			// this.clearNotion();
			this.cityid = cid;
			this.countyid = cuid;
			this.provinceid = pid;
			this.getEnterpriseList(1, 'sort');
		},
		//清空概念选项
		clearNotion() {
			this.notionNumRefresh++;
			this.isClearNotion = true;
			this.notionCode = 0;
		},
		//概念单选 层级显示
		chooseNotion(chooseNotionlist, notionCode, step) {
			this.notionCode = notionCode;
			if (step) {
				this.notionstep = step;
			}
			var sortStr = (step && step < 3) ? 'sort' : '';
			this.getEnterpriseList(1, sortStr);
		},



	},
}
</script>

<style></style>